export const en = {
  title: {
    preview_mode: "Preview mode",
    test_mode_on: "Test mode ON"
  },
  sending: "Sending ...",
  registration_process_failed: "Registration process failed.",
  it_is_possible_that_multiple_windows_or_tabs_are_currently_in_operation: "It is possible that multiple windows or tabs are currently in operation.",
  please_check_your_browser_and_then_try_again: "Please check your browser and then try again."
};